import UpdateIcon from '@mui/icons-material/Update';
import { Box, Button, Stack, Typography } from '@mui/material';

export const ChunkLoadError = () => {
  return (
    <Box
      position="absolute"
      left="50%"
      top="50%"
      sx={{ transform: 'translate(-50%,-50%)' }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        border="1px solid"
        borderColor="divider"
        borderRadius="2px"
        spacing={2}
        py={4}
        px={6}
        mt={-8}
      >
        <UpdateIcon color="action" sx={{ fontSize: 40 }} />
        <Box>
          <Typography variant="body1">We have updated the app.</Typography>
          <Typography variant="body1">
            Please refresh to see the latest changes.
          </Typography>
        </Box>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </Stack>
    </Box>
  );
};
